/** @format */

import template from './gb-thermometer-widget.html';
import './gb-thermometer-widget.scss';

export const GbThermometerWidgetComponent = {
    require: {
        gbWidget: '^^',
    },
    template,
    controller: class GbThermometerWidgetComponent {
        constructor($gbAuctionImage, $scope) {
            'ngInject';

            this.$gbAuctionImage = $gbAuctionImage;
            this.widgetUuid = undefined;
            this.$scope = $scope;
        }

        $onInit() {
            this.widgetUuid = this.gbWidget.widget.uuid;
            this.setClipTransitionStyle();
            this.setPercentageWatchers();
        }

        setPercentageWatchers() {
            let watchExpr = () => {
                return this.getWidget().fundraising_progress;
            };
            let watchListener = (newProgress, oldProgress) => {
                if (newProgress !== oldProgress) this.setClipTransitionStyle();
            };
            this.$scope.$watch(watchExpr, watchListener, true);
        }

        setClipTransitionStyle() {
            this.clipTransitionStyle = `.clip-transition-${this.widgetUuid} {
                transition: all 0.3s ease-in;
                -webkit-clip-path: inset(${this.getPercentage()} 0 0 0);
                clip-path: inset(${this.getInversePercentage()} 0 0 0);
            }`;
        }

        getWidget() {
            return this.gbWidget.widget;
        }

        getRawPercentage() {
            let progress = Math.round(this.getWidget().fundraising_progress * 100);

            if (progress > 100) {
                progress = 100;
            }

            return progress;
        }

        getPercentage() {
            return `${this.getRawPercentage()}%`;
        }

        // This is used for the basic thermometer style.
        // We use the inverse value because this is the height of a shape
        // that covers the thermometer colour, and is anchored to the top.
        getInversePercentage() {
            let inverse = 100 - this.getRawPercentage();
            return `${inverse}%`;
        }

        hasImage() {
            return !!(this.getWidget() && this.getWidget().custom_image);
        }

        getAuctionImage() {
            if (this.hasImage()) {
                return this.getWidget().custom_image;
            }
        }

        getStyles() {
            let widget = this.getWidget();

            if (!widget) {
                return;
            }

            let styles = {};

            if (!widget.width) {
                styles.width = 'auto';
            }

            if (!widget.height) {
                styles.height = 'auto';
            }

            return styles;
        }
    },
};
